export default __webpack_public_path__ + "static/security-dark-42d0881f3a9a3d2b9c41326b191760ae.png";